import type { Ranges } from 'api/System/types'
import config from 'config'
import { selectSkipRefetchOmsOrigins } from 'data/selectors'
import { getRequestParams } from 'data/utils'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { RequestDate } from 'types/UI'
import { fetchAction } from 'utils'

import * as constants from './constants'

interface FetchAction {
  dateCurrent: RequestDate
  dateCompared?: RequestDate | null
  range: Ranges
}

const fetchOmsOrigins = createLogic<State, FetchAction>({
  type: constants.FETCH_OMS_ORIGIN,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const anyAction = action as any
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, anyAction)
      const skipRefetch = selectSkipRefetchOmsOrigins(action.payload as any)(state)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_OMS_ORIGIN_DONE,
          payload: action.payload,
        })
      } else {
        const response = await fetchAction(config.api.omsOrigins, {
          ...getRequestParams(anyAction, ['storesType']), // ecoms, necoms, etc.
          ...baseRequestParams,
        })

        dispatch({
          type: constants.FETCH_OMS_ORIGIN_SUCCESS,
          payload: {
            ...anyAction.payload,
            data: response.data,
          },
        })
      }
    } catch (error) {
      dispatch({
        ...action,
        type: constants.FETCH_OMS_ORIGIN_ERROR,
      })
    }
    done()
  },
})

export default [fetchOmsOrigins]
